import { authHeader } from '../_helpers/auth-header';
import Config from '../_helpers/config'
export const StockService = {
    refuse,
    accept,
    verify,
    reset,
    setSent,
    fetchData,
    getNotifications,

};

function fetchData(id, state) {

    const base_url = `${Config.ApiUrl}/stock/${state}/detail`;
    const init = { method: 'GET', accept: 'application/json', headers: authHeader() };


    return fetch(`${base_url}?id=${id}`, init)

}
function getNotifications() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader() ,
    };
    return fetch(`${Config.ApiUrl}/stock/getAlerts`, requestOptions).then(handleResponse)
}

function accept(id, amount, remarks) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader() ,
        body: JSON.stringify({ id, amount, remarks })
    };



    return fetch(`${Config.ApiUrl}/stock/accept`, requestOptions).then(handleResponse)

}

function refuse(id, amount, remarks) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader() ,
        body: JSON.stringify({ id, amount, remarks })
    };

    return fetch(`${Config.ApiUrl}/stock/refuse`, requestOptions).then(handleResponse)

}
function verify(id, amount, remarks) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader() ,
        body: JSON.stringify({ id, amount, remarks })
    };

    return fetch(`${Config.ApiUrl}/stock/verify`, requestOptions).then(handleResponse)

}
function reset(id, amount, remarks) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader() ,
        body: JSON.stringify({ id, amount, remarks })
    };

    return fetch(`${Config.ApiUrl}/stock/reset`, requestOptions).then(handleResponse)

}
function setSent(items)
{
    console.log(items);
    const requestOptions = {
        method: 'POST',
        headers: authHeader() ,
        body: JSON.stringify(items.map((i)=>i.id))
    };

    return fetch(`${Config.ApiUrl}/stock/setSent`, requestOptions).then(handleResponse)
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}
function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}